"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:181dece5-4b5a-413d-a516-2d97f85f4064",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_USOVqXwPC",
    "aws_user_pools_web_client_id": "414c4bpmjjlmpo7301dvdvrep9",
    "oauth": {}
};
exports.default = awsmobile;
